import { Spin } from "antd";
import styles from "./KeywordCloud.module.scss";
import useDeviceCheck from "Hooks/useDeviceCheck";
import SectionTitle from "../SectionTitle";
import { IconPack } from "Explore/Config/Icons";
import KeywordCloudD3 from "../KeywordCloud2";
import { motion } from "framer-motion";

const KeywordCloud = ({
  concept,
  selectedKeywords,
  setSelectedKeywords,
  granularityLevel,
  setGranularityLevel,
  granularityLevelQueue,
  setGranularityLevelQueue,
  selectedKeywordsQueue,
  setSelectedKeywordsQueue,
  sliderValue,
  setSliderValue,
  timeFilterType,
  timeFilter,
  setTimeFilter,
  hideOperation,
  padding,
  scaleFactor,
  chart_height = 300,
  maxFontSize,
  minFontSize,
  hideTitle,
}) => {
  const { isMobile } = useDeviceCheck();

  const renderKeyword = () => {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className={styles["keyword-cloud-container"]}
      >
        {concept.isLoading && (
          <div className={styles["loading"]} style={{ height: chart_height }}>
            <Spin />
          </div>
        )}
        <KeywordCloudD3
          keywords={concept.data}
          selectedKeywords={selectedKeywords}
          setSelectedKeywords={setSelectedKeywords}
          granularityLevel={granularityLevel}
          setGranularityLevel={setGranularityLevel}
          granularityLevelQueue={granularityLevelQueue}
          setGranularityLevelQueue={setGranularityLevelQueue}
          selectedKeywordsQueue={selectedKeywordsQueue}
          setSelectedKeywordsQueue={setSelectedKeywordsQueue}
          sliderValue={sliderValue}
          setSliderValue={setSliderValue}
          timeFilterType={timeFilterType}
          timeFilter={timeFilter}
          setTimeFilter={setTimeFilter}
          // bigCloud={false}
          hideOperation={hideOperation}
          scaleFactor={scaleFactor}
          containerPadding={isMobile ? 16 : 60}
          padding={padding}
          chart_height={chart_height}
          maxFontSize={maxFontSize || (isMobile ? 20 : 26)}
          minFontSize={minFontSize || (isMobile ? 12 : 16)}
        />
        {/* {concept.data?.length > 0 ? (
          <KeywordCloudD3
            keywords={concept.data}
            selectedKeywords={selectedKeywords}
            setSelectedKeywords={setSelectedKeywords}
            granularityLevel={granularityLevel}
            setGranularityLevel={setGranularityLevel}
            selectedKeywordsQueue={selectedKeywordsQueue}
            setSelectedKeywordsQueue={setSelectedKeywordsQueue}
            sliderValue={sliderValue}
            setSliderValue={setSliderValue}
            timeFilterType={timeFilterType}
            timeFilter={timeFilter}
            setTimeFilter={setTimeFilter}
            // bigCloud={false}
            hideOperation={hideOperation}
            scaleFactor={scaleFactor}
            containerPadding={isMobile ? 16 : 60}
            padding={padding}
            chart_height={chart_height}
            maxFontSize={maxFontSize || (isMobile ? 20 : 26)}
            minFontSize={minFontSize || (isMobile ? 12 : 16)}
          />
        ) : (
          <Empty
            description="No keyword found!"
            style={{ height: chart_height }}
          />
        )} */}
      </motion.div>
    );
  };

  return (
    <div style={{ position: "relative", zIndex: 1, width: "100%" }}>
      {isMobile && !hideTitle ? (
        <SectionTitle
          title={"Interests"}
          icon={IconPack.wordcloud}
          collapsible
          defaultOpen
        >
          {renderKeyword()}
        </SectionTitle>
      ) : (
        renderKeyword()
      )}
    </div>
  );
};

export default KeywordCloud;
